"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorNameValues = [
    'background',
    'active',
    'black',
    'white',
    'border',
    'shadowInset',
    'brandOrange',
    'brand',
    'control',
    'focus',
    'placeholder',
    'text',
    'primaryText',
    'secondaryText',
    'tertiaryText',
    'accordionText',
    'primaryBlue-1',
    'primaryBlue-2',
    'primaryBlue-3',
    'secondaryBlue-1',
    'secondaryBlue-2',
    'secondaryBlue-3',
    'grey-1',
    'grey-2',
    'grey-3',
    'grey-4',
    'grey-5',
    'grey-6',
    'grey-7',
    'grey-8',
    'grey-9',
    'grey-10',
    'dark-1',
    'dark-2',
    'dark-3',
    'dark-4',
    'dark-5',
    'dark-6',
    'light-1',
    'light-2',
    'light-3',
    'light-4',
    'light-5',
    'light-6',
    'status-critical',
    'status-error',
    'status-warning',
    'status-ok',
    'status-unknown',
    'status-disabled'
];
exports.MarginSideValues = ['top', 'bottom', 'left', 'right', 'vertical', 'horizontal', 'all'];
exports.SizeNameValues = [
    'none',
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge',
    'huge',
    'xhuge',
    'full'
];
exports.SpacingDirectionValues = ['horizontal', 'vertical', 'top', 'bottom', 'left', 'right'];
//# sourceMappingURL=base.types.js.map